import React, { useEffect, useState } from 'react';
import { customersApi } from '../services/api';

export default function Customers() {
  const [customers, setCustomers] = useState([]);
  const [total, setTotal] = useState(0);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [form, setForm] = useState({ name: '', email: '', phone: '', address: '', city: '', zip: '', notes: '' });
  const [saving, setSaving] = useState(false);
  const [ico, setIco] = useState('');
  const [icoLoading, setIcoLoading] = useState(false);

  function load() {
    setLoading(true);
    customersApi.list({ search, limit: 100 }).then(r => { setCustomers(r.data); setTotal(r.total); }).finally(() => setLoading(false));
  }
  useEffect(() => { load(); }, [search]);

  async function aresLookup() {
    if (!ico) return;
    setIcoLoading(true);
    try {
      const data = await customersApi.aresLookup(ico);
      setForm(f => ({ ...f, name: data.name, address: data.address, city: data.city, zip: data.zip, ico }));
    } catch { alert('IČO nenalezeno v ARES'); }
    finally { setIcoLoading(false); }
  }

  async function save(e) {
    e.preventDefault();
    setSaving(true);
    try {
      if (selected) {
        await customersApi.update(selected.id, form);
      } else {
        await customersApi.create(form);
      }
      setShowModal(false);
      load();
    } finally { setSaving(false); }
  }

  function openNew() {
    setSelected(null);
    setForm({ name: '', email: '', phone: '', address: '', city: '', zip: '', notes: '' });
    setIco('');
    setShowModal(true);
  }

  function openEdit(c) {
    setSelected(c);
    setForm({ name: c.name, email: c.email, phone: c.phone, address: c.address, city: c.city, zip: c.zip, notes: c.notes });
    setShowModal(true);
  }

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">👥 Zákazníci</h1>
        <button className="btn btn-primary" onClick={openNew}>+ Nový zákazník</button>
      </div>

      <div className="card" style={{ marginBottom: 16, padding: '12px 16px' }}>
        <div className="filters">
          <input className="form-control" style={{ width: 260 }} placeholder="Hledat..." value={search} onChange={e => setSearch(e.target.value)} />
          <span style={{ fontSize: 13, color: 'var(--text-muted)' }}>Celkem: {total}</span>
        </div>
      </div>

      <div className="card">
        {loading ? <div className="loading-center"><div className="spinner" /></div> : (
          <div className="table-wrap">
            <table>
              <thead><tr><th>Jméno</th><th>Email</th><th>Telefon</th><th>Město</th><th>IČO</th><th></th></tr></thead>
              <tbody>
                {customers.map(c => (
                  <tr key={c.id}>
                    <td style={{ fontWeight: 600 }}>{c.name}</td>
                    <td style={{ fontSize: 13 }}>{c.email || '—'}</td>
                    <td style={{ fontSize: 13 }}>{c.phone || '—'}</td>
                    <td style={{ fontSize: 13 }}>{c.city || '—'}</td>
                    <td style={{ fontSize: 12, color: 'var(--text-muted)' }}>{c.ico || '—'}</td>
                    <td><button className="btn btn-secondary btn-sm" onClick={() => openEdit(c)}>Upravit</button></td>
                  </tr>
                ))}
              </tbody>
            </table>
            {customers.length === 0 && <div className="empty-state">Žádní zákazníci</div>}
          </div>
        )}
      </div>

      {showModal && (
        <div className="modal-overlay" onClick={e => e.target === e.currentTarget && setShowModal(false)}>
          <div className="modal">
            <div className="modal-header">
              <div className="modal-title">{selected ? 'Upravit zákazníka' : 'Nový zákazník'}</div>
              <button className="btn btn-secondary btn-sm" onClick={() => setShowModal(false)}>✕</button>
            </div>
            <form onSubmit={save}>
              <div className="modal-body">
                {!selected && (
                  <div className="form-group">
                    <label className="form-label">Lookup IČO (ARES)</label>
                    <div style={{ display: 'flex', gap: 8 }}>
                      <input className="form-control" placeholder="12345678" value={ico} onChange={e => setIco(e.target.value)} style={{ flex: 1 }} />
                      <button type="button" className="btn btn-secondary" onClick={aresLookup} disabled={icoLoading}>{icoLoading ? '...' : 'Vyhledat'}</button>
                    </div>
                  </div>
                )}
                {[['name','Jméno *',true],['email','Email',false],['phone','Telefon',false],['address','Adresa',false],['city','Město',false],['zip','PSČ',false]].map(([f,l,req]) => (
                  <div className="form-group" key={f}>
                    <label className="form-label">{l}</label>
                    <input className="form-control" value={form[f]} onChange={e => setForm(p => ({...p, [f]: e.target.value}))} required={req} />
                  </div>
                ))}
                <div className="form-group">
                  <label className="form-label">Poznámka</label>
                  <textarea className="form-control" value={form.notes} onChange={e => setForm(p => ({...p, notes: e.target.value}))} rows={3} />
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>Zrušit</button>
                <button type="submit" className="btn btn-primary" disabled={saving}>{saving ? 'Ukládám...' : 'Uložit'}</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
